import { useEffect } from 'react';
import { Column, Row, CircularProgress } from '@tempmee/react';
import { borderRadius, shadows } from '@tempmee/tailwind';
import history from '../../../browserHistory';
import { EmptyChatIcon } from '../../../images/icons/EmptyChatIcon';
import Messages from '../../messages/Messages';
import { EmptyInbox } from '../Empty';
import { useConversations } from '~/domain/Messages';
import { useInfiniteScrollTrigger } from '~/hooks';

export const Chat = ({ isRootComponent }) => {
  const {
    conversations: chats,
    isLoading,
    isFinalPage,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useConversations({ filter: 'unread' });

  const triggerFetchNextPage = useInfiniteScrollTrigger({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  useEffect(() => {
    const handleScroll = () => {
      const atBottom =
        window.scrollY + window.innerHeight >= document.documentElement.scrollHeight;
      triggerFetchNextPage(atBottom);
    };

    if (isRootComponent) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isRootComponent, triggerFetchNextPage]);

  const onScrollListener = (e) => {
    const el = e.currentTarget;
    triggerFetchNextPage(el.scrollHeight - el.scrollTop <= el.clientHeight);
  };

  if (isLoading && chats.length === 0) {
    return (
      <Row align="center" justify="center" style={{ width: '100%', flex: 1, minHeight: 300 }}>
        <CircularProgress />
      </Row>
    );
  }

  if (!isLoading && chats.length === 0) {
    return (
      <EmptyInbox
        Icon={EmptyChatIcon}
        title="No chats yet!"
        description={
          <>
            Get started by reaching out to a professional
            <br />
            once they&apos;re scheduled for their shift.
          </>
        }
        descriptionStyle={{ textAlign: 'center' }}
      />
    );
  }

  const selectedMessage = (job) => {
    history.push(`/dashboard/chat/${job.id}`, { jobId: job.id });
  };

  return (
    <Column
      onScroll={onScrollListener}
      style={{
        borderRadius: borderRadius.pill,
        boxShadow: shadows['elevation-4'],
        maxHeight: isRootComponent ? undefined : 500,
        overflowY: 'scroll',
        flex: 1,
      }}
    >
      <Messages isLoading={isLoading} conversations={chats} selectedJobs={selectedMessage} />
      {!isFinalPage && isFetchingNextPage && <CircularProgress />}
    </Column>
  );
};
